import { ICAreaMeta } from "./icareameta";
import { ICMetaDefaultValue } from "./icmetadefaultvalue";
import { ICMetaDescriptionArea } from "./icmetadescriptionarea";
import { ICSchedulation } from "./icschedulation";
import { Translation } from "./translation";

export class ICMetaDescription {
  Automatic: boolean;
  Code: string;
  DefaultValue: string;
  DefaultValues: ICMetaDefaultValue[];
  DeleteDate: string;
  Id: number;
  IdGuid: string;
  InputFormat: string;
  InsertDate: string;
  LastEditDate: string;
  Level: number;
  MetaDescriptionArea: ICMetaDescriptionArea[];
  Metas: ICAreaMeta[];
  Name: Translation[];
  Order: number;
  RegexValidation: string;
  Required: boolean;
  Schedulations: ICSchedulation[];
  Type: string;
  UserEditable: boolean;
  Visible: boolean;

  constructor(data?: Partial<ICMetaDescription>) {
    Object.assign(this, data);
  }
}
